//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueSlider from 'vue-slider-component'
import {insightService} from "@/insight-service"
import {mapGetters, mapMutations} from 'vuex'
import 'vue-slider-component/theme/default.css'

export default {
  name: "FacetedSearch",

  components: {VueSlider},

  mounted() {
    this.$refs.fetchLabels.get().then((labels) => {
      this.labels = labels;
    });
    this.modelsPP.params.queryParams = '("false")';
    this.modelsPP.fetch().then((results) => {
      let models = results.entries;
      models = models.filter((model) => insightService.isLive(model));
      this.setModels(models);
      this.inputs = results.aggregations.ai_model_inputs_name_agg.buckets;
      this.outputs = results.aggregations.ai_model_outputs_name_agg.buckets;
      this.createdDates = results.aggregations.dublincore_created_agg.buckets;
      this.creators = results.aggregations.dublincore_creator_agg.buckets;
      this.states = results.aggregations.system_currentLifeCycleState_agg.buckets;
      this.algos = results.aggregations.ai_model_algo_agg.buckets;
      this.publishStates = results.aggregations.ai_model_publish_state_agg.buckets;

      // init slider for documents count
      this.docsMax = results.aggregations.documents_count_max.value;
      this.docsCount = [0, this.docsMax];
      this.count = [0, this.docsMax];
      this.$refs.sliderCount.max = this.docsMax; // workaround to force component re-rendering
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters([
      'allModels', 'modelsPP'
    ])
  },

  methods: {
    search(e) {
      this.displayClear = true;
      if (e !== undefined && e.keyCode && e.keyCode !== 13) {
        return;
      }
      const isVersion = this.selectedLabels && this.selectedLabels.length !== 0;
      return insightService.listModelsPP(this.modelsPP, this.fulltext, this.getAggregates(), isVersion)
          .then((response) => {
            let models = response.entries;
            if (this.isOnlyFavorite) {
              models = response.entries.filter((model) => insightService.isFavorites(model));
            }
            this.setModels(models);
          }).catch((error) => {
            console.error(error);
            this.displayError('Cannot search for models');
          });
    },
    getAggregates() {
      return {
        system_currentLifeCycleState_agg: this.selectedStates,
        dublincore_created_agg: this.selectedCreatedDates,
        dublincore_creator_agg: this.selectedCreators,
        ai_model_outputs_name_agg: this.selectedOutputs,
        ai_model_inputs_name_agg: this.selectedInputs,
        ai_model_publish_state_agg: this.selectedPublishStates,
        ai_model_algo_agg: this.selectedAlgos,
        ai_model_main_result_min: this.perf[0] / 100,
        ai_model_main_result_max: this.perf[1] / 100,
        ai_model_documents_count_min: this.docsCount[0],
        ai_model_documents_count_max: this.docsCount[1],
        labels: this.selectedLabels,
      };
    },
    clear() {
      this.selectedInputs = [];
      this.perf = [0, 100];
      this.docsCount = [0, this.docsMax];
      this.selectedOutputs = [];
      this.selectedAlgos = [];
      this.selectedPublishStates = [];
      this.selectedStates = [];
      this.selectedLabels = [];
      this.selectedCreators = [];
      this.selectedCreatedDates = [];
      this.fulltext = '';
      this.isOnlyFavorite = false;
      this.search();
      this.displayClear = false;
    },
    ...mapMutations({
      displaySuccess: 'displaySuccess',
      displayError: 'displayError',
      setModels: 'setModels',
    })
  },

  data: () => ({
    loading: true,
    fulltext: "",
    isOnlyFavorite: false,
    perf: [0, 100],
    percent: [0, 100],
    docsMax: 100,
    docsCount: [],
    count: [],
    inputs: [],
    labels: [],
    outputs: [],
    publishStates: [],
    states: [],
    algos: [],
    createdDates: [],
    creators: [],
    selectedInputs: [],
    selectedOutputs: [],
    selectedStates: [],
    selectedLabels: [],
    selectedCreators: [],
    selectedCreatedDates: [],
    selectedPublishStates: [],
    selectedAlgos: [],
    displayClear: false,
  }),
}
